import { Page } from '@/core/architecture'

import { ConsoleUserOwnedItemsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleUserOwnedItems Page
 * Implemented as a practical sample.
 */
export const ConsoleUserOwnedItems: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleUserOwnedItemsTemplate state={state} {...actions} />
}
